'use client'

import { useEffect, useState } from 'react'

type Props = {
  list: string[]
}

export const RollintText = ({ list }: Props) => {
  const [index, setIndex] = useState(0)
  const [sliding, setSliding] = useState(false)
  const [animated, setAnimated] = useState(false)

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimated(true)
      setSliding(true)

      setTimeout(() => {
        setAnimated(false)
        setSliding(false)
        setIndex(prev => (prev + 1) % list.length)
      }, 350)
    }, 3000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  const nextIndex = (index + 1) % list.length

  return (
    <div className="relative h-12 overflow-hidden">
      <span
        className="typo-title1 absolute inset-x-0 font-bold ease-in-out"
        style={{
          transform: sliding ? 'translateY(-100%)' : 'translateY(0)',
          transition: animated ? 'transform 350ms ease-in-out' : 'none',
        }}
      >
        {list[index]}
      </span>
      <span
        className="typo-title1 absolute inset-x-0 font-bold ease-in-out"
        style={{
          transform: sliding ? 'translateY(0)' : 'translateY(100%)',
          transition: animated ? 'transform 350ms ease-in-out' : 'none',
        }}
      >
        {list[nextIndex]}
      </span>
    </div>
  )
}
